import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as epics from '../../epics'

export const RESOURCE = {
  payload: {
    description: 'One Jira epic, keyed by its Jira key. Only Jira writes it.',
    dimension: epics.RESOURCE.payload,
    level: 0,
    name: 'Epic',
    partialId: PartialId.Standard.create('epic'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
